import React from 'react'

import { useResult } from '../hooks'

import styles from './SearchResult.module.css'

const SearchResult = ({ resultId }) => {
  const [result, { select }] = useResult(resultId)

  return (
    <li className={styles.item} onClick={select}>
      {result.address}
    </li>
  )
  // return (
  //   <li className={styles.item} onClick={select}>
  //     <img
  //       className={styles.icon}
  //       alt={reason}
  //       src={BASE_URL + 'images/icons/' + getIconFromReason(reason)}
  //     />
  //     <div className={styles.title}>{label}</div>
  //   </li>
  // )
}
export default SearchResult
